import { CONTENT_URL } from "../api/Definitions"
import { iImageVersions, eImageVersions } from "../definitions/Image"

export function useImageUrl(
  version: eImageVersions = eImageVersions.original,
  versions: iImageVersions = {},
) {
  const pp = versions[eImageVersions[version]]?.meta?.pipePath

  if (pp) {
    return `${CONTENT_URL}${pp}`
  }
  return ""
}
